module.exports = __webpack_public_path__ + "static/media/samstaffing.c2e5821c.png";